import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Button } from "antd";

class UISteps extends Component {
	static propTypes = {
		steps         : PropTypes.arrayOf(
			PropTypes.shape({
				key      : PropTypes.string.isRequired,
				label    : PropTypes.string,
				stepLabel: PropTypes.string,
				disabled : PropTypes.bool,
			}),
		).isRequired,
		current       : PropTypes.string.isRequired,
		onChange      : PropTypes.func.isRequired,
		onCancel      : PropTypes.func,
		cancelLabel   : PropTypes.string,
		backLabel     : PropTypes.string,
		nextLabel     : PropTypes.string,
		allowStepClick: PropTypes.bool,
		nextDisabled  : PropTypes.bool,
		lastAction    : PropTypes.node,
		hideNav       : PropTypes.bool,
	};

	static defaultProps = {
		onCancel      : () => null,
		cancelLabel   : "Cancelar",
		backLabel     : "Voltar",
		nextLabel     : "Próximo",
		allowStepClick: true,
		nextDisabled  : false,
		lastAction    : null,
		hideNav       : false,
	};

	_currentIndex = () => this.props.steps.findIndex(step => step.key === this.props.current);

	_goToIndex = (index) => {
		const {steps, onChange} = this.props;

		if( index < 0 || index >= steps.length || steps[index].disabled )
		{
			return;
		}

		onChange(steps[index].key);
	};

	_handleBack = () => {
		const index = this._currentIndex();

		if( index <= 0 )
		{
			this.props.onCancel();
		}
		else
		{
			this._goToIndex(index - 1);
		}
	};

	_handleNext = () => {
		this._goToIndex(this._currentIndex() + 1);
	};

	render() {
		const {steps, cancelLabel, backLabel, nextLabel, allowStepClick, nextDisabled, lastAction, hideNav} = this.props;

		const currentIndex = this._currentIndex();
		const isFirst = currentIndex <= 0;
		const isLast = currentIndex >= steps.length - 1;
		const nextStep = steps[currentIndex + 1];
		const isNextDisabled = nextDisabled || Boolean(nextStep?.disabled);

		return (
			<div className={`ui-steps ${hideNav ? "ui-steps-track-only" : ""}`}>
				{!hideNav && (
					<div className="ui-steps-slot ui-steps-slot-back">
						<Button className="ui-steps-btn-back" onClick={this._handleBack}>
							<i className="fal fa-arrow-left" /> {isFirst ? cancelLabel : backLabel}
						</Button>
					</div>
				)}
				<div className="ui-steps-track">
					{steps.map((step, index) => (
						<React.Fragment key={step.key}>
							{index > 0 && <div className={`ui-steps-line ${index <= currentIndex ? "done" : ""}`} />}
							<div className="ui-steps-item">
								<div
									className={`ui-steps-dot ${index === currentIndex ? "active" : ""} ${index < currentIndex ? "done" : ""} ${step.disabled ? "disabled" : (allowStepClick ? "clickable" : "")}`}
									onClick={() => allowStepClick && this._goToIndex(index)}
								>
									{index < currentIndex ? <i className="fas fa-check" /> : index + 1}
								</div>
								{(step.stepLabel || step.label) && <div className={`ui-steps-label ${index === currentIndex ? "active" : ""}`}>{step.stepLabel || step.label}</div>}
							</div>
						</React.Fragment>
					))}
				</div>
				{!hideNav && (
					<div className="ui-steps-slot ui-steps-slot-next">
						{isLast ? lastAction : (
							<Button type="primary" className="ui-steps-btn-next" onClick={this._handleNext} disabled={isNextDisabled}>
								{nextLabel} <i className="fal fa-arrow-right" />
							</Button>
						)}
					</div>
				)}
			</div>
		);
	}
}

export default UISteps;
